module.exports = __webpack_public_path__ + "static/media/img24.0753066d.JPG";